import React from 'react'
import { useSelector } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'

export const  ProductTag = ({merchandiseId,isFormDisabled,updateData,saveData, invoiceId}) =>{
  
  const sku=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.sku)
  return (
    <Grid.Column width='8' className='divFormFeild b-rw-0 b-tlr-5'>
      <InputField
        isLabel={false}
        id={`sku-${invoiceId}-${merchandiseId}`}
        type='text'
        label='Sku/Part'
        mandatory={false}
        value={sku}
        className='field-bg'
        clearInput={false}
        disabled={isFormDisabled}
        onChange={(value) =>updateData({sku:value})}
        onBlur={() =>saveData({sku:sku || " "})}
      />
    </Grid.Column>
  )
}

export default React.memo(ProductTag)
